import 'rc-drawer/assets/index.css'
import React from 'react'
// import Drawer from 'rc-drawer'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import MenuLeft from './MenuLeft'
import {compose} from "redux";

const mapStateToProps = ({settings}) => ({
  isMobileMenuOpen: settings.isMobileMenuOpen,
  isMobileView: settings.isMobileView,
  isLightTheme: settings.isLightTheme,
})

class AppMenu extends React.Component {
  toggleOpen = () => {
    const {dispatch, isMobileMenuOpen} = this.props;
    document
      .querySelector('#root')
      .setAttribute(
        'style',
        !isMobileMenuOpen ? 'overflow: hidden; width: 100%; height: 100%;' : '',
      );
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMobileMenuOpen',
        value: !isMobileMenuOpen,
      },
    })
  };

  render() {
    const BootstrappedMenu = () => (
      <MenuLeft />
    );
    return BootstrappedMenu()
  }
}

export default compose(withRouter, connect(mapStateToProps))(AppMenu)
